var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"10","height":"8","viewBox":"0 0 10 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M4.99996 0.75L9.7631 7.5H0.236816L4.99996 0.75Z","fill":"#333333"}})])}
var staticRenderFns = []

export { render, staticRenderFns }